import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { ExcelNodeView } from "../tiptap-node/excel-block-node/excel-node-view";

export const ExcelTableNode = Node.create({
  name: "excelTable",

  group: "block",
  atom: true,

  addAttributes() {
    return {
      data: {
        default: JSON.stringify({
          columns: [],
          rows: [],
        }),
      },
    };
  },

  parseHTML() {
    return [{ tag: "excel-table" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["excel-table", mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(ExcelNodeView);
  },
});
